import { LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeId from '@angular/common/locales/id';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MsalGuard, MsalModule } from '@azure/msal-angular';
import { environment } from '../environments/environment';
import {
  BrowserCacheLocation,
  InteractionType,
  LogLevel,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
} from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DATE_PICKER_FORMATS } from './app-config.const';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './core/auth/guard';
import { AuthInterceptor, ErrorInterceptor } from './core/interceptor';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ModalModule } from 'ngx-bootstrap/modal';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

registerLocaleData(localeId);

export function loggerCallback(logLevel: LogLevel, message: string) {
	console.log(message);
  }

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		NgIdleKeepaliveModule.forRoot(),
		ModalModule.forRoot(),
		BrowserAnimationsModule,
		MsalModule.forRoot(
			new PublicClientApplication({
			  // MSAL Configuration
			  auth: {
				clientId: environment.azure.clientId,
				authority: environment.azure.authority,
				redirectUri: environment.baseUrl,
			  },
			  cache: {
				cacheLocation: BrowserCacheLocation.LocalStorage,
				storeAuthStateInCookie: isIE, // set to true for IE 11
			  },
			  system: {
				allowNativeBroker: false, // Disables WAM Broker
				loggerOptions: {
				  loggerCallback,
				  logLevel: LogLevel.Info,
				  piiLoggingEnabled: false
				}
			  }
			}),
			{
			  interactionType: InteractionType.Popup, // MSAL Guard Configuration
			  authRequest: {
				scopes: ['user.read'],
			  },
			},
			{
			  interactionType: InteractionType.Popup, // MSAL Interceptor Configuration
			  protectedResourceMap: new Map([
				['https://graph.microsoft.com/v1.0/me', ['user.read']],
			  ]),
			},
		  ),
	],
	providers: [
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE],
		},
		{
			provide: MAT_DATE_FORMATS,
			useValue: DATE_PICKER_FORMATS,
		},
		{
			provide: LOCALE_ID,
			useValue: 'id',
		},
		AuthGuard,
		MsalGuard,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true,
		},

	],
	bootstrap: [AppComponent],
})
export class AppModule {}
